export default __webpack_public_path__ + "static/media/floorBase.2af01a14.jpeg";